import {Client} from '../../../graphql/types'

const IB_ID = [
  10078,
  10169,
  10162,
  10083,
  10096,
  10029,
  10093,
  10088,
  10084,
  10085,
  10230,
  10188,
  10227,
  10206,
  10227,
  10183,
  10235,
  10249,
  10237,
  10236,
  10244,
  10268,
  10212,
  10270,
  10248,
  10238,
  10209,
  10274,
  10213,
  10272,
  10276,
  10275,
  10279,
  10289,
  10226,
  10281,
  10291,
  10292,
  10293,
  10296,
  10300,
  10301,
  10302,
  10097,
  10305,
  10307,
  10295,
  10318,
  10297,
  10246,
  10322,
  10224,
  10320,
  10222,
  10329,
  10303,
  10316,
  10324,
  10340,
  10358,
  10346,
  10333,
  10338,
  10332,
  10341,
  10342,
  10350,
  10354,
  10330,
  10327,
  10355,
  10326,
  10319,
  10361,
  10367,
  10319,
  10353,
  10359,
  10363,
  10371,
  10372,
  10345,
  10373,
  10334,
  10325,
  10167,
  10166,
  10376,
  10377,
  10365,
  10382,
  10383,
  10384,
  10357,
  10369,
  10375,
  10328,
  10381,
]

export const overrideForIB = (accounts: any[], client: Client) => {
  if (!client.metadata) return accounts

  let metadata: any
  try {
    metadata = JSON.parse(client.metadata)
  } catch (err) {
    console.warn('Failed to parse metadata:', client.metadata)
    return accounts
  }

  const remoteIbId = metadata?.ibFollowerData?.remoteIbId

  if (!IB_ID.includes(remoteIbId)) return accounts

  return accounts.filter(
    (account) =>
      !['black', 'raw', 'mt5Raw', 'mt5Vip'].includes(account.accountSubtype) &&
      account.category !== 'affiliate',
  )
}
